import {
  GET_LIST_REPORTS,
  UPDATE_LIST_REPORTS,
  UPDATE_LOADING_REPORTS
} from '@/modules/neodash/store/modules/reports/types';
import {ReportsService} from '@/modules/neodash/services/reportsService';
import uuid from 'uuid';

export const actions = {
  [GET_LIST_REPORTS]: ({commit, state}) => {
    if (state.isLoadingListReports)
      return;

    sessionStorage.setItem('SESSION_ID', uuid().replaceAll('-', ''));
    commit(UPDATE_LOADING_REPORTS, true);
    ReportsService.ListAllReports()
        .then(lst => {
          commit(UPDATE_LIST_REPORTS, lst);
          commit(UPDATE_LOADING_REPORTS, false);
        });
  },
};
